import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as currentPageActions from "../../../../../../store/actions/currentPageActions";
import PropTypes from "prop-types";
import { useHistory, useParams } from "react-router";
import {
  getBreadCrumpsV2,
  routeBack,
  setBreadCrumpsV2,
} from "./M_BreadCrumbs.helper";

const useStyles = makeStyles((theme) => ({
  titleWrapper: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
    gap: "2px",
    [theme.breakpoints.up("md")]: {
      marginTop: "-0.25em",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
  breadcrumbTrail: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
    gap: "2px",
  },
  prevItem: {
    fontSize: "0.9rem",
    fontWeight: 500,
    color: "var(--color-primary-text)",
    cursor: "pointer",
    letterSpacing: "0.01em",
    whiteSpace: "nowrap",
    textDecoration: "underline",
    textUnderlineOffset: "2px",
    transition: "color 0.18s ease, opacity 0.18s ease",
    borderRadius: "calc(4px * var(--app-radius-scale, 1))",
    padding: "2px 4px 6px 4px",
    "&:hover": {
      color: "var(--color-primary-text)",
      opacity: 0.8,
      textDecoration: "underline",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.6875rem",
      maxWidth: "120px",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  separator: {
    color: "var(--color-text-secondary)",
    opacity: 0.5,
    fontSize: "1.125rem",
    flexShrink: 0,
  },
  currentTitle: {
    fontSize: "1rem",
    fontWeight: 600,
    color: "var(--color-text-primary)",
    textTransform: "capitalize",
    letterSpacing: "0.01em",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.75rem",
    },
  },
  subtitle: {
    fontSize: "0.85rem",
    fontWeight: 400,
    color: "var(--color-text-secondary)",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.6875rem",
    },
  },
}));

const M_TemplatePageTitle = (props) => {
  const classes = useStyles();
  const { crmId, pageUrl, templateId } = useParams();
  const history = useHistory();
  const [previousDetails, setPreviousDetails] = React.useState();

  React.useEffect(() => {
    setBreadCrumpsV2({
      pageUrl,
      crmId,
      templateId,
      title: props.title || props.toolbar.PageTitle,
    });
    setPreviousDetails(getBreadCrumpsV2());
  }, [pageUrl, crmId, templateId]);

  const currentTitle = props.title
    ? props.title
    : props.toolbar && props.toolbar.PageTitle
    ? props.toolbar.PageTitle
    : previousDetails && previousDetails.title && previousDetails.title !== ""
    ? pageUrl
    : "";

  const hasPrevious =
    previousDetails && previousDetails.title && previousDetails.title !== "";

  return (
    <div id="PageTitleWrapper" className={classes.titleWrapper}>
      <div className={classes.breadcrumbTrail}>
        {hasPrevious && (
          <>
            <span
              className={classes.prevItem}
              onClick={() => {
                routeBack();
                history.push(
                  `/${previousDetails.pageUrl}/${previousDetails.crmId}/${previousDetails.templateId}`
                );
              }}
            >
              {previousDetails.title}
            </span>
            <NavigateNextIcon className={classes.separator} />
          </>
        )}
        <span className={classes.currentTitle}>{currentTitle}</span>
        {props.subtitle && (
          <>
            <NavigateNextIcon className={classes.separator} />
            <span className={classes.subtitle}>{props.subtitle}</span>
          </>
        )}
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    currentPage: state.currentPage,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({}, currentPageActions), dispatch);
}
M_TemplatePageTitle.propTypes = {
  toolbar: PropTypes.object,
  optionSets: PropTypes.array,
  currentPage: PropTypes.object,
  primary: PropTypes.object,
  logo: PropTypes.any,
  title: PropTypes.any,
  subtitle: PropTypes.any,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(M_TemplatePageTitle);
